import React from "react";

import { GA4EventNames } from "@vahak/core/dist/constants/event-names";
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";

import AppImg from "../../../../utils/AppImg";
import HomepageV2Animate from "../../../../homepage-v2/animate/HomepageV2Animate";
import useValidateUserStatus from "../../../../../hooks/useValidateUserStatus";
import { POSTING_FORM_MODAL_ORIGINATION_PAGE, useLoadLorryPosting } from "../../../../../context/load-lorry-posting";
import { LORRY_CREATION_FORM_IDS } from "../../../../posting/helpers/constants";
import { IEventTrackerProp } from "../../../../../types/events";
import { MARKETPLACE_V3_ASSETS } from "../marketplaceV3.constants";
import useMarketplaceV3Translation from "../useMarketplaceV3Translation";
import Styles from "./MarketplaceV3NoLoadsEmptyState.module.scss";

const MarketplaceV3NoLoadsEmptyState = ({ trackEvent, eventData }: IEventTrackerProp) => {
    const { t } = useMarketplaceV3Translation();
    const { ValidateLorryPosting } = useValidateUserStatus();
    const loadLorryPostingConfig = useLoadLorryPosting();

    const handlePostLorry = () => {
        trackEvent?.(GA4EventNames.MARKET_PLACE.add_lorry_attach_lorry_btn, {
            ...eventData,
            from_screen: "empty_marketplace_v3"
        });

        ValidateLorryPosting(() => {
            loadLorryPostingConfig?.updateLoadLorryPostingData({
                isModalOpen: true,
                category: "post",
                originationPage: POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE,
                type: "lorry"
            });
            loadLorryPostingConfig?.openLorryPostingModal(LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER);
        });
    };

    return (
        <div className={Styles.emptyState}>
            <HomepageV2Animate variant="fade-up">
                <div className={Styles.illustration}>
                    <AppImg
                        src={MARKETPLACE_V3_ASSETS.noLoadAvailableImage}
                        alt={t("loads.empty.titleLine")}
                        width={1000}
                        height={441}
                        unoptimized
                    />
                </div>
            </HomepageV2Animate>

            <HomepageV2Animate variant="fade-up" delay={80}>
                <h2 className={Styles.title}>
                    <span className={Styles.titleLine}>{t("loads.empty.titleLine")}</span>
                    <span className={Styles.titleHighlight}>{t("loads.empty.titleHighlight")}</span>
                </h2>
            </HomepageV2Animate>

            <HomepageV2Animate variant="fade-up" delay={120}>
                <p className={Styles.description}>
                    {t("loads.empty.descriptionPrefix")}
                    <span className={Styles.descriptionBold}>{t("loads.empty.descriptionBold")}</span>
                    {t("loads.empty.descriptionSuffix")}
                </p>
            </HomepageV2Animate>

            <HomepageV2Animate variant="fade-up" delay={160}>
                <button type="button" className={Styles.ctaBtn} onClick={handlePostLorry}>
                    <span>{t("loads.empty.cta")}</span>
                    <ArrowRightWhite aria-hidden />
                </button>
            </HomepageV2Animate>
        </div>
    );
};

export default MarketplaceV3NoLoadsEmptyState;
